import React, { useMemo } from 'react';
import clsx from 'clsx';

import { isAnyVisibleChildren } from '../../common/isAnyVisibleChildren';
import { DivPropsWithoutRef } from '../../common';

export interface DropdownMenuProps extends DivPropsWithoutRef {
  /**
   * Слот для заголовка
   */
  header?: React.ReactNode;
  /**
   * Слот для списка значений
   */
  children?: React.ReactNode;
  /**
   * Слот дополнительного контента
   */
  after?: React.ReactNode;
  /**
   * Реф на элемент заголовка
   */
  headerRef?: React.Ref<HTMLDivElement>;
  /**
   * Реф на элемент списка значений
   */
  itemsRef?: React.Ref<HTMLDivElement>;
  /**
   * Режим, в котором не рисуется рамка
   */
  borderless?: boolean;
}

export const DropdownMenu = React.forwardRef<HTMLDivElement, DropdownMenuProps>(
  (
    {
      header,
      children,
      className,
      after,
      headerRef,
      itemsRef,
      borderless,
      ...props
    },
    ref
  ) => {
    const showItems = useMemo(() => isAnyVisibleChildren(children), [children]);
    return (
      <div
        ref={ref}
        className={clsx('hse-DropdownMenu', className, {
          'hse-DropdownMenu_empty': !showItems && !header,
          'hse-DropdownMenu_borderless': borderless
        })}
        {...props}
      >
        {header && (
          <div ref={headerRef} className="hse-DropdownMenu__header">
            {header}
          </div>
        )}
        {showItems && (
          <div ref={itemsRef} className="hse-DropdownMenu__items">
            {children}
          </div>
        )}
        {after}
      </div>
    );
  }
);
